export default __webpack_public_path__ + "static/media/instagram.f446893b.svg";